import {FormFieldType} from "@pg-mono/form";

import {IFavouritesListApplicationFormValues} from "./IFavouritesListApplicationFormValues";

export const getInitialFavouritesListApplicationFormValues = () => {
    const initialValues: IFavouritesListApplicationFormValues = {
        name: "",
        email: "",
        phone: {
            code: 48,
            number: ""
        },
        marketing_email: false,
        marketing_sms: false
    };

    return initialValues;
};

export const favouritesListApplicationFormFields = {
    name: FormFieldType.Input,
    email: FormFieldType.Input,
    phone: FormFieldType.PhoneField,
    marketing_email: FormFieldType.Checkbox,
    marketing_sms: FormFieldType.Checkbox
};
import {FormFieldType} from "@pg-mono/form";

import {IFavouritesListApplicationFormValues} from "./IFavouritesListApplicationFormValues";

export const getInitialFavouritesListApplicationFormValues = () => {
    const initialValues: IFavouritesListApplicationFormValues = {
        name: "",
        email: "",
        phone: {
            code: 48,
            number: ""
        },
        marketing_email: false,
        marketing_sms: false
    };

    return initialValues;
};

export const favouritesListApplicationFormFields = {
    name: FormFieldType.Input,
    email: FormFieldType.Input,
    phone: FormFieldType.PhoneField,
    marketing_email: FormFieldType.Checkbox,
    marketing_sms: FormFieldType.Checkbox
};
